'use strict';

import Listing from './listing';

export default class LoadMoreListing extends Listing {
    constructor(el) {
        super(el);
    }

    initPagination() {

    }

    updatePagination(document) {

    }

    removePagination() {
        if (this.loadMoreElement) {
            this.container.removeChild(this.loadMoreElement);
            this.loadMoreElement = null;
        }
    }
}



// WEBPACK FOOTER //
// ./app/components/listing/js/pagination-listing.js